import Backbone from "backbone";
import * as _ from "underscore";

// Represents the selected models within a collection.
// Can be a list of or the entire group.

/* collection should be a Backbone Collection with the following extra attributes:
 *  @param {number}   totalCount    - total number of items (including those not shown)
 *  @param {function} performAction - performs an action on all selected items
 *  @param {function} searchQuery   - performs an action on all selected items
 */

const SelectionModel = Backbone.Model.extend({
  initialize: function () {
    const that = this;
    this.collection = this.get("collection");

    this.on("change:wholePage change:wholeCollection change:itemIDs", () => {
      that.updateCount();
    });
    this.on("change:itemIDs", this.indexItems.bind(this));
  },
  defaults: {
    itemIDs: [],
    wholeCollection: false,
    wholePage: false,
    count: 0,
  },
  addItem: function (itemID) {
    this.addItems([itemID]);
  },
  addItems: function (itemIDs) {
    this.set("itemIDs", _.union(this.get("itemIDs"), itemIDs));
    if (this.get("itemIDs").length === this.collection.length) {
      this.set("wholePage", true);
    }
  },
  removeItems: function (itemIDs) {
    this.set("itemIDs", _.difference(this.get("itemIDs"), itemIDs));
  },
  removeItem: function (itemID) {
    const itemIDs = _.clone(this.get("itemIDs")),
      index = itemIDs.indexOf(itemID);

    this.set("wholeCollection", false);
    this.set("wholePage", false);
    if (index !== -1) {
      itemIDs.splice(index, 1);
      this.set("itemIDs", itemIDs);
    }
  },
  set: function (key, value) {
    // do pre-set stuff
    if (key === "itemIDs") {
      this.indexItems(value);
    }
    // eslint-disable-next-line prefer-rest-params
    return Backbone.Model.prototype.set.apply(this, arguments as any);
  },
  indexItems: function (newItemIDs) {
    this.itemIndex = {};
    _.each(newItemIDs, (itemID) => {
      this.itemIndex[itemID] = true;
    });
  },
  selectWholePage: function () {
    this.set("wholePage", true);
    this.set("itemIDs", this.collection.pluck("_id"));
  },
  selectWholeCollection: function () {
    this.set("wholeCollection", true);
    this.set("itemIDs", this.collection.pluck("_id"));
  },
  clearSelection: function () {
    this.set("wholeCollection", false);
    this.set("wholePage", false);
    this.set("itemIDs", []);
  },
  getPageCount: function () {
    return this.collection.length;
  },
  updateCount: function () {
    let count;
    if (this.get("wholeCollection")) {
      count = this.collection.totalCount;
    } else {
      count = this.get("itemIDs").length;
    }
    this.set("count", count);
  },
  getTotalCount: function () {
    return this.collection.totalCount;
  },
  performAction: function (action) {
    let filteredSelection;

    if (this.get("wholeCollection") || this.get("wholePage")) {
      filteredSelection = this;
    } else {
      filteredSelection = this.getFilteredSelection((item) => {
        return action.appliesToItem(item);
      });
    }

    if (this.collection.performAction) {
      this.collection.performAction(action.id, filteredSelection);
    } else if (typeof this.collection[action.id] === "function") {
      this.collection[action.id].bind(this.collection)(filteredSelection);
    } else {
      console.error("action not available: ", action);
    }
  },
  getFilteredSelection: function (filterFunction) {
    const filteredIDs = [];
    _.each(this.getSelectedItems(), (item) => {
      if (filterFunction(item)) {
        filteredIDs.push(item.id);
      }
    });
    return new SelectionModel({
      itemIDs: filteredIDs,
      collection: this.collection,
      count: filteredIDs.length,
    });
  },
  // TODO: this is word-specific
  isDeleted: function () {
    return (
      this.collection.searchQuery &&
      this.collection.searchQuery.get("wordGroup") === "deleted"
    );
  },
  getFirstSelected: function (limit) {
    const that = this;
    const itemIDs = _.first(this.get("itemIDs"), limit || 25);

    return _.map(itemIDs, (itemID) => {
      return that.collection.get(itemID);
    });
  },
  getQuery: function () {
    if (this.get("wholeCollection")) {
      return this.collection.searchQuery.toJSON();
    } else {
      return {
        itemIDs: this.get("itemIDs").join("|"),
      };
    }
  },
  getSelectedItems: function () {
    return _.map(this.get("itemIDs"), (itemID) => {
      return this.collection.get(itemID);
    });
  },
});

export default SelectionModel;
